<template>
    <div>
        <div v-if="sub_material_estimate_date">
            <el-tag size="mini">预计入库:{{ sub_material_estimate_date }}</el-tag>
        </div>
        <div v-if="sub_material_finish_time">
            <el-tag size="mini">实际入库: {{ sub_material_finish_time }}</el-tag>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ApplySubFinishDate",
        props: {
            order: Object
        },
        computed: {
            /**
             * 面料实际入库时间
             */
            sub_material_finish_time() {
                if (this.order.applyinfo) {
                    return this.order.applyinfo.sub_material_finish_time
                }
                return ''
            },

            /**
             * 面料预计入库时间
             */
            sub_material_estimate_date() {
                if (this.order.applyinfo) {
                    return this.order.applyinfo.sub_material_estimate_date
                }
                return ''
            },
        },
    }
</script>

<style scoped>

</style>